import { Text, Title } from "@clipboard-health/ui-components";
import { DialogContent, Link, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { UnverifiedBadgeCounter } from "@src/appV2/redesign/WorkBadges/components/Policy/UnverifiedBadgeCounter";

export interface SkippedBadgeVerificationContentProps {
  unverifiedBadgeCount: number;
  onClockIn: () => void;
  onViewBadgePolicy: () => void;
  onNeedNewBadge: () => void;
}

export function SkippedBadgeVerificationContent(props: SkippedBadgeVerificationContentProps) {
  const { unverifiedBadgeCount, onClockIn, onViewBadgePolicy, onNeedNewBadge } = props;

  return (
    <Stack sx={{ height: "100%" }}>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack spacing={12} alignItems="center" sx={{ textAlign: "center" }}>
          <Title
            component="h1"
            variant="h2"
            sx={(theme) => ({ color: theme.palette.intent?.error.text })}
          >
            You have skipped badge verification
          </Title>

          <UnverifiedBadgeCounter
            unverifiedBadgeCount={unverifiedBadgeCount}
            textSx={(theme) => ({ color: theme.palette.text.primary })}
          />

          <Text variant="body1" color={(theme) => theme.palette.text.secondary}>
            After the shift, order a badge from your{" "}
            <Link
              component="button"
              variant="body1"
              sx={{ verticalAlign: "baseline" }}
              onClick={onNeedNewBadge}
            >
              account page
            </Link>{" "}
            for your next badge-required shift.
          </Text>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onClockIn}>
          Clock in
        </Button>
        <Button fullWidth variant="text" size="large" onClick={onViewBadgePolicy}>
          View badge policy
        </Button>
      </DialogFooter>
    </Stack>
  );
}
